<template>
  <TaskList
    title="Bank Statement"
    taskType="bank_statement"
  >
  </TaskList>
</template>

<script>
import TaskList from '@/components/TaskList.vue';

export default {
  components: {
    TaskList
  },
}
</script>
